export interface GoogleAddressPlaceFilter {
  placeType: GoogleAddressPlaceFilterTypes;
}
export enum GoogleAddressPlaceFilterTypes {
  PostalCode = 'postal_code',
}
